module.exports = __webpack_public_path__ + "img/step4.5e97b623.png";